<template>

<div class='col-12'>

    <loading-div v-if='!isReady'></loading-div>
        
    <div class='alert alert-info mt-4 mb-4' v-if='isReady && !offers.length'>
        <span class="icon icon-info3"></span>
        Не сте подавали оферти за тази процедура
    </div>

    <div class='row'>

        <div v-if='!showForm && !$parent.tp.offer_id' class="col-12 mb-5">
            <button @click='showForm = !showForm' class='btn btn-lg btn-primary'>
                <span class="icon icon-plus-circle"></span>
                Подай оферта
            </button>
        </div>

        <div v-if='showForm' class="col-12 mb-5">
            <fieldset class="fieldset h-100 mb-0">
                
                <h3 class="fieldset-title">Заяви участие в този търг</h3>

                <div class='form-group'>
                    <label for='cost'>Цена</label>
                    <input type="number" class='form-control' id='cost' 
                           v-model.number='offer.cost'>
                </div>

                <div class='form-group'>
                    <label for='days'>Срок ( брой дни )</label>
                    <input type="number" class='form-control' id='days' 
                           v-model.number='offer.days'>
                </div>

                <div class='form-group'>
                    <label for='desc'>Допълнителна информация</label>
                    <textarea class='form-control' id='desc' v-model.trim='offer.desc'>
                    </textarea>
                </div>

                <div class='alert alert-info'>
                    <span class="icon icon-submit"></span>
                    След успешно подаване на оферта, ще можете да добавите изображения и документи към нея ( ако има нужда ).
                </div>

                <div class="d-flex justify-content-between align-items-center">
                    <button @click='addOffer' class='btn btn-lg btn-primary'>
                        <span class="icon icon-plus-circle"></span>
                        Подай оферта
                    </button>
                    <button @click='showForm = false' class='btn btn-outline-info'>
                        Затвори
                    </button>
                </div>

            </fieldset>
        </div>

    </div>

    <div class='row' v-if='isReady && offers.length'>

        <div class="col-12 mt-3">
            <h2>Подадени от теб оферти : </h2>
        

            <div :class='["tenders", { winner : $parent.tp.offer_id == o.id }]'
                 v-for='o in offers'>
                
                <div v-if='$parent.tp.offer_id == o.id' class="logo-check">
                    <img src="/resources/images/check.svg" alt="Logo Videa" >
                    <strong>Победител</strong>
                </div>

                <div class="tender-offer mb-3 pb-md-5">
                    <h4 class="mb-1">
                        Данни за офертата: 
                    </h4>

                    <div>
                        Цена: <strong class="txt-orange">{{ o.cost }} BGN</strong>
                    </div>
                    <div>
                        Срок: <strong class="txt-orange">{{ o.days }} дни</strong>
                    </div>
                    <div class="mt-4">
                        Описание:<br>
                        <strong>{{ o.desc }}</strong>
                    </div>
                </div>

                <div v-if='!o.files.length' class='alert alert-info'>
                    <span class="icon icon-info3"></span>
                    Няма прикачени файлове към тази оферта
                </div>

                <div v-if='o.files.length' class="tender-files row">

                    <div class="col-12">
                        <ul class="list-inline d-flex justify-content-center justify-content-lg-end align-items-center files-view admin-files-view">
                            <li @click="grid = false" :class="[ 'list-inline-item', { active : !grid }]">
                                <span class="icon icon-list"></span>
                            </li>

                            <li @click="grid = true" :class="[ 'list-inline-item', { active : grid }]">
                                <span class="icon icon-grid"></span>
                            </li>
                        </ul>
                    </div>
                
                    <div class="col-12">
                        <div :class="{ 'grid-view' : grid, 'list-view' : !grid  }">
                            <file-grid :files='o.files' 
                                   :conf='getGridConfig(o)'
                                   :params='{ o : o.id }'
                                   v-on:file-removed='fileRemoved'></file-grid>
                        </div>
                    </div>

                </div>

                <hr/>
                <dropzone :conf='getConfig(o)' v-on:upload-success="addFile"></dropzone>
            </div>
        </div>

    </div>

</div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        created() {

           this.offer = Object.assign( {}, this.offerModel );
        
        },

        data() {
            return {

                isReady : false,
                offers  : [],
                offer   : false,
                showForm : false,
                grid    : true,

                offerModel : {
                    cost : 0,
                    days : 0,
                    desc : '',
                    project_tp_id : this.$parent.tp.id
                },


            }
        },

        methods : {

            getData() {

                this.ajax.call('tp:gof', { tp : this.$parent.tp.id }, (r) => {

                    if( r.status == 'success' ) {

                        this.offers  = r.data;
                        this.isReady = true;

                        this.$parent.tp.previews++;
                    
                    } else {

                        $.notify( r.message, r.status );
                    }

                })

            },

            addOffer() {

                if( !this.offer.cost ) {
                    $.notify('Моля въведете цена за офертата','warning');
                    $("#cost").focus();

                    return;
                }

                if( !this.offer.days ) {
                    $.notify('Моля въведете брой дни за офертата','warning');
                    $("#days").focus();

                    return;
                }

                this.isLoading = true;

                this.ajax.call('tp:adof', this.offer , (r) => {

                    this.isLoading = false;

                    if( r.status == 'success' ) {

                        this.offers.push( r.data );
                        this.offer = Object.assign({}, this.offerModel);
                        this.showForm = false;

                        $.notify("Офертата ви беше добавена успешно","success");

                        this.$parent.tp.offers++;
                    
                    } else {

                        $.notify( r.message, r.status );
                    }

                })

            },

            addFile( f ) {

                for( var i in this.offers ) {
                    if( this.offers[i].id == f.project_tp_offer_id ) {
                        this.offers[i].files.push( f );
                    }
                }

                $.notify("Файлът беше качен успешно","success");

            },

            getConfig( offer ) {

                return {
                    id  : 'dz-' + offer.id,
                    url : '/system/tp:up',
                    acceptFiles: ['image/*','application/pdf'],
                    alowedText : 'Разрешени формати : jpg, jpeg, png, txt, pdf',
                    params : {
                        tpo : offer.id
                    }
                };

            },

            getGridConfig(o) {

                return {
                    info        : "",
                    lightBoxId  : 'offer-' + o.id,
                    download    : true,
                    removeUrl   : 'tp:rmf',
                    remove      : true
                }
            },

            fileRemoved( idx, params ) {

                for( var i in this.offers ) {

                    if( this.offers[i].id == params.o ) {
                        
                        this.offers[i].files.splice( idx, 1 );

                        return;
                    }
                }
            } 

        }

    }
</script>
